import React from 'react'

/**
 * Binds all the methods of a (class instance) object that are inherited from a
 * prototype. Object is altered in place.
 *
 * Usage:
 * constructor () {
 *   bind(this)
 * }
 *
 * @deprecated
 * @param {object} instance
 * @return {object}
 */
export function bind(instance) {
    const prototype = Object.getPrototypeOf(instance)

    if (prototype.constructor === Object) {
        return instance
    }

    Object.getOwnPropertyNames(prototype).forEach(key => {
        const prototypeProp = prototype[key]
        if (typeof prototypeProp === 'function' && key !== 'constructor') {
            instance[key] = prototypeProp.bind(instance)
        }
    })

    return instance
}

/**
 * Checks if a ReactElement is an instance of some component class.
 * @param {ReactElement} element
 * @param {Constructor} PotentialClass
 * @return {boolean}
 */
export function isElementOf(element, PotentialClass) {
    if (!element || !element.type || !element.type.prototype) {
        return false
    }

    return element.type === PotentialClass || element.type.prototype instanceof PotentialClass
}

/**
 * Gets all the properties from props, that are not defined in the propTypes
 * @param {object} propTypes
 * @param {object} props
 * @returns {*}
 */
export function getExtraneousProps(propTypes, props) {
    const extraneousProps = Object.assign({}, props)
    Object.keys(propTypes).forEach(key => {
        delete extraneousProps[key]
    })
    return extraneousProps
}
